import React from 'react';

import { SUPER_BATCH_MODULE_TYPE_OPTIONS } from '@moduleManagement/data/coreSuperBatchModuleTypeOptions';
import Select from 'components/Select';
import styles from './BacthModuleTypeSelect.module.scss';

function BatchModuleTypeSelect(props) {
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: 0.8,
      border: 'none',
      outline: 'none',
      boxShadow: 'none',
    }),
  };

  return (
    <Select
      {...props}
      placeholder={props.placeholder}
      styles={_styles}
      options={SUPER_BATCH_MODULE_TYPE_OPTIONS}
      className={styles.comp}
    />
  );
}

export default BatchModuleTypeSelect;
